import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';




export const selectedReviewItemStyles = makeStyles((theme) => ({
    selectedReviewItem: {
        

        '& .selected-review-item': {
            
            '&-inner': {
                display: 'flex',
                marginTop: theme.spacing(.5),
                [theme.breakpoints.down('sm')]: {
                    justifyContent: 'space-between',
                },
                '&.mobile-stack': {
                    [theme.breakpoints.down('sm')]: {
                        display: 'block',
                    },
                },
            },
            '&-content': {
                display: 'flex',
                [theme.breakpoints.up('sm')]: {
                    width: '50%',
                },
            },
            '&-icon': {
                marginRight: theme.spacing(.5),

                '&.added': {
                    fill: tcsmColors.green,
                },
                '&.removed': {
                    fill: tcsmColors.red,
                },
            },
            '&-caption': {
                color: tcsmColors.greyTwo,

            },
            '&-subtext': {
                '&.green-text': {
                    color: tcsmColors.green,
                },
                '&.red-text': {
                    color: tcsmColors.red,
                },
            },
        },
        

    },
    


}));
